import * as React from 'react';
import * as cn from 'classnames';

const map = require('../../../../assets/svg/map.svg') as string;

import * as styles from './map.css';
import * as grid from '../../../../styles/grid.css';

export const Map: React.SFC<{}> = () => {
  return (
    <section className={styles.mapContainer}>
      <div className={grid.container}>
        <h2>We're hiring all over</h2>
        <div className={styles.map}>
          <img src={map} />

          <div className={styles.pins}>
            <span className={cn(styles.tooltip, styles.newYork)}>New York</span>

            <span className={cn(styles.tooltip, styles.london)}>London</span>

            <span className={cn(styles.tooltip, styles.warsaw)}>Warsaw</span>

            <span className={cn(styles.tooltip, styles.bengaluru)}>Bengaluru</span>

            <span className={cn(styles.tooltip, styles.hongKong)}>Hong Kong</span>

            <span className={cn(styles.tooltip, styles.tokyo)}>Tokyo</span>
          </div>
        </div>

        <div className={styles.list}>
          <ul>
            <li>New York</li>
            <li>Bengaluru</li>
            <li>London</li>
            <li>Hong Kong</li>
            <li>Warsaw</li>
            <li>Tokyo</li>
          </ul>
        </div>
      </div>
    </section>
  );
};
